import { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import clsx from "clsx";
import IconImages2 from "@ui/central-icons/icons/IconImages2";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";

export function Dropzone({
  acceptedMimeTypes,
  maxFiles,
  onFilesDrop,
  dropzoneLabel,
  dropzoneIcon,
  openRef,
}: {
  acceptedMimeTypes: string;
  maxFiles: number;
  onFilesDrop?: (files: File[]) => void;
  dropzoneLabel?: string;
  dropzoneIcon?: React.ReactNode;
  openRef: React.MutableRefObject<(() => void) | null>;
}) {
  const accept = useMemo(
    () => Object.fromEntries(acceptedMimeTypes.split(",").map(t => [t.trim(), []])),
    [acceptedMimeTypes],
  );

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    multiple: maxFiles > 1,
    noClick: false,
    accept,
    maxFiles,
    onDropAccepted: files => {
      onFilesDrop?.(files);
    },
  });

  openRef.current = open;

  return (
    <div
      {...getRootProps()}
      className='tw-group tw-flex tw-w-fit tw-cursor-pointer tw-flex-col tw-gap-2.5 tw-px-2 tw-pt-2 tw-outline-none'
    >
      <input {...getInputProps()} />

      {/* Tile with icon + label inside — matches xi AssetAttachmentEmpty */}
      <div
        className={clsx(
          "tw-flex tw-h-[74px] tw-w-fit tw-shrink-0 tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-[14px] tw-border tw-border-dashed tw-border-transparent tw-bg-black/[0.04] tw-px-5 tw-transition tw-duration-200 group-focus-visible:tw-outline-focus",
          isDragActive ? "tw-border-black/30 tw-bg-black/[0.08]" : "hover:tw-bg-black/[0.06]",
        )}
      >
        <span className='tw-text-black/30'>
          {dropzoneIcon ?? <IconImages2 className={`${iconStrokeFix} tw-size-[18px]`} />}
        </span>
        {dropzoneLabel && <span className='tw-type-xs tw-font-medium tw-text-black/40'>{dropzoneLabel}</span>}
      </div>
    </div>
  );
}
